<div aria-hidden="true" class="timeline-header" *ngIf="timelines && timelines.length > 0">
  <p class="incoming">
    {{ 'commons:basic.timeline.incoming' | translate }}
  </p>
  <p class="outgoing">
    {{ 'commons:basic.timeline.outgoing' | translate }}
  </p>
</div>
<ul class="timeline-body">
  <ng-container *ngFor="let year$ of [head$, tail$]">
    <ng-container *ngFor="let wrapper of year$ | async">
      <li class="tag time-separator">
        <p>{{ wrapper.label | translate }}</p>
      </li>
      <li
        class="tag"
        aria-live="polite"
        *ngFor="let entry of wrapper.entries"
        [ngClass]="[entry.id === selectInteractionId ? 'selected' : '', entry.canalName | lowercase, entry.canalDirection | lowercase]"
        [class.not-handled-phone]="entry.isNotHandledPhone"
        [cngTooltip]="tooltipContentRef"
        placement="right"
      >
        <button class="date" (click)="select(entry)">{{ entry.beginDate | localizedDate: 'shortDate' }}</button>
        <ng-template #tooltipContentRef>
          <dl>
            <div *ngIf="activeCompany" (element-check-fn)="$ctrl.checkCompanyName($event)" class="section">
              <dt>{{ 'commons:basic.timeline.contact' | translate }}</dt>
              <dd>{{ entry.contactEntry.contactFirstName || ' ' }} {{ entry.contactEntry.contactLastName }}</dd>
            </div>
            <!-- DATE -->
            <div class="section">
              <dt>
                {{ 'commons:basic.timeline.date' | translate }}
              </dt>
              <dd>
                {{ entry.beginDate | localizedDate: 'short' }}
              </dd>
            </div>
            <!-- CHANNEL -->
            <div class="section">
              <dt>
                {{ 'commons:basic.timeline.channel' | translate }}
              </dt>
              <dd>
                {{ ('commons:basic.channels.' + entry.canalName + '_' + entry.canalDirection | translate) || '-' }}
              </dd>
            </div>
            <!-- CSR -->
            <div class="section">
              <dt>
                {{ 'commons:basic.timeline.csr' | translate }}
              </dt>
              <dd>{{ computeAgentName(entry.contactEntry) }}</dd>
            </div>
            <!-- DESCRIPTION -->
            <div class="section">
              <div *ngIf="entry.canalName | mapper: isPhone; else notPhone">
                <dt>
                  {{ 'commons:basic.callingType.phone_number' | translate }}
                </dt>
                <dd>{{ entry.contactEntry.contactUri || '-' }}</dd>
              </div>

              <ng-template #notPhone>
                <dt>
                  {{ 'commons:basic.timeline.object' | translate }}
                </dt>
                <dd>{{ entry.description || '-' }}</dd>
              </ng-template>
            </div>
            <!-- SKILLS -->
            <div class="section" *ngIf="entry?.contactEntry?.skills?.length > 0">
              <dt>{{ 'commons:basic.skill' | translate | capitalize }}</dt>
              <dd *ngFor="let skill of entry.contactEntry.skills">{{ skill.name }}</dd>
            </div>
          </dl>
        </ng-template>
      </li>
    </ng-container>
  </ng-container>
</ul>
